export const TABLET_THRESHOLD = 1210;
export const MOBILE_THRESHOLD = 468;
export const MOBILE_SMALL_THRESHOLD = 388;
export const EMAIL_PASSWORD_CONNECTION_NAME = 'Username-Password-Authentication';

export const CPAAS_TERMS_URL = 'https://www.8x8.com/cpaas-order-terms/cpaas-service-terms';
export const JAAS_TERMS_URL = 'https://www.8x8.com/cpaas-order-terms/jaas-module';
export const PRIVACY_POLICY_URL = 'https://www.8x8.com/terms-and-conditions/privacy-policy';
export const TERMS_OF_SERVICE_LINK = 'https://www.8x8.com/order-terms/vo-vcc-service-terms';

export const SUPPORTED_LANGUAGES = [
  'de',
  'en',
  'es',
  'es-419',
  'pt',
  'pt-BR',
];
export const SOURCES = {
  MEET: 'VideoMeetings',
}

export const VPAAS_MODES = {
  SIMPLE: 'simple',
  DEFAULT: 'default',
}
